export const API_BASE_URL: string = import.meta.env.VITE_BASE_URL;
export const SOCKET_URL: string = import.meta.env.VITE_SOCKET_URL;
export const TINY_MCE_WYSIWYG_EDITOR_KEY: string = import.meta.env.VITE_TINY_MCE_KEY;
export const GOOGLE_RECAPTCHA_KEY: string = import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY;
export const GOOGLE_ANALYTICS_ID: string = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
